<app-layout><app-breadcrumbs [items]="breadcrumbItems"></app-breadcrumbs><router-outlet></router-outlet></app-layout>